"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuccessData = exports.getPsnCountry = exports.isDirectPlatform = exports.getCardImage = exports.getBalance = exports.getWalletId = exports.getCardValue = exports.getDisplayNameForPlatform = exports.regionBlockedAccounts = exports.generatePlatformOptions = exports.validConnectedAccount = exports.hasExternalAccount = exports.getLocalizedPlatformName = exports.getPlatformLongToShort = exports.getPlatformShortToLong = exports.getPlatformLangCode = exports.isPosaCodeValid = exports.PosaCodePattern = void 0;
const types_1 = require("./types");
// 16 chars xxxx-xxxx-xxxx-xxxx
exports.PosaCodePattern = /^[A-Z|a-z|0-9|-]{16,20}$/;
exports.isPosaCodeValid = code => exports.PosaCodePattern.test(code);
exports.getPlatformLangCode = (platform) => {
    switch (platform) {
        case 'pc':
            return 'epic.code.redemption.pcMac';
        case 'psn':
            return 'epic.code.redemption.psn';
        case 'mobile':
            return 'epic.code.redemption.mobile';
        case 'xbl':
            return 'epic.code.redemption.xbl';
        case 'nintendo':
            return 'epic.code.redemption.nintendo';
        default:
        // no-op
    }
    return null;
};
exports.getPlatformShortToLong = (platform) => {
    switch (platform) {
        case 'pc':
            return types_1.PosaPlatforms.EPIC;
        case 'mobile':
            return types_1.PosaPlatforms.MOBILE;
        case 'psn':
            return types_1.PosaPlatforms.PSN;
        case 'xbl':
            return types_1.PosaPlatforms.XBL;
        case 'nintendo':
            return types_1.PosaPlatforms.SWITCH;
        default:
            return types_1.PosaPlatforms.EPIC;
    }
};
exports.getPlatformLongToShort = (platform) => {
    switch (platform) {
        case types_1.PosaPlatforms.EPIC:
            return 'pc';
        case types_1.PosaPlatforms.PSN:
            return 'psn';
        case types_1.PosaPlatforms.MOBILE:
            return 'mobile';
        case types_1.PosaPlatforms.XBL:
            return 'xbl';
        case types_1.PosaPlatforms.SWITCH:
            return 'nintendo';
        default:
        // no-op
    }
    return null;
};
exports.getLocalizedPlatformName = (platform, localizedMessage) => {
    const msgCode = exports.getPlatformLangCode(platform);
    if (!msgCode)
        return '';
    return localizedMessage(msgCode) || '';
};
exports.hasExternalAccount = (platform, externalAuths) => {
    for (const external of externalAuths) {
        if (external.type === platform)
            return true;
    }
    return false;
};
exports.validConnectedAccount = (platform, connectedPlatforms) => {
    if (['pc', 'mobile'].includes(platform))
        return true;
    for (const account of connectedPlatforms) {
        if (account.platform === platform && account.redeemable)
            return true;
    }
    return false;
};
/**
 * Generate platform options based on the externalAuths availabe
 * @param {*} externalAuths externalAuths from PosaRedeemStore
 * @param {*} message message func that will return the correct Label locale
 */
exports.generatePlatformOptions = (externalAuths, localizedMessage) => {
    if (!externalAuths)
        throw new Error('generatePlatformOptions missing params');
    const defaults = [
        {
            label: exports.getLocalizedPlatformName('pc', localizedMessage),
            value: 'pc',
            disabled: false
        },
        {
            label: exports.getLocalizedPlatformName('psn', localizedMessage),
            value: 'psn'
        },
        {
            label: exports.getLocalizedPlatformName('mobile', localizedMessage),
            value: 'mobile',
            disabled: false
        },
        {
            label: exports.getLocalizedPlatformName('xbl', localizedMessage),
            value: 'xbl'
        },
        {
            label: exports.getLocalizedPlatformName('nintendo', localizedMessage),
            value: 'nintendo'
        }
    ];
    return defaults
        .map(item => {
        const clone = Object.assign({}, item);
        const platform = clone.value;
        // if disabled property is not pre defined (PC and Mobile),
        // we consider it will always be eligit for user to redeem
        if (clone.disabled === undefined) {
            clone.disabled = !exports.hasExternalAccount(platform, externalAuths);
        }
        return clone;
    })
        .sort((a, b) => {
        if (a.disabled === b.disabled) {
            return a.value < b.value ? -1 : 0;
        }
        if (a.disabled)
            return 1;
        return -1;
    });
};
exports.regionBlockedAccounts = (connectedPlatforms) => connectedPlatforms.filter(account => !account.redeemable);
/**
 * get epicAccountName for each platform
 * @param {*} platform
 * @param {*} externalAuths
 */
exports.getDisplayNameForPlatform = (platform, externalAuths) => {
    let displayName = null;
    try {
        for (const auth of externalAuths) {
            if (auth.type === platform) {
                displayName = auth.externalDisplayName || null;
                break;
            }
        }
    }
    catch (ex) {
        // no-op
    }
    return displayName;
};
exports.getCardValue = offer => {
    let value = null;
    try {
        value = offer.customAttributes.VBucks_Value.value;
    }
    catch (ex) {
        // no-op
    }
    return value;
};
exports.getWalletId = (platform) => {
    switch (platform) {
        case 'pc':
        case 'mobile':
            return 'EPIC';
        case 'psn':
            return 'SONY';
        case 'nintendo':
            return 'NINTENDO';
        case 'xbl':
            return 'XBOX_LIVE';
        default:
        // no-op
    }
    return '';
};
exports.getBalance = (wallets, platform) => {
    const walletId = exports.getWalletId(platform);
    try {
        if (walletId) {
            for (const wallet of wallets) {
                if (wallet.walletId === walletId) {
                    return wallet.balance;
                }
            }
        }
    }
    catch (ex) {
        // no-op
    }
    return null;
};
exports.getCardImage = offer => {
    let image = null;
    try {
        const { keyImages } = offer;
        for (const keyImage of keyImages) {
            if (keyImage.type === 'POSA') {
                image = keyImage.url;
                break;
            }
        }
    }
    catch (ex) {
        // no-op
    }
    return image;
};
/**
 * PSN and XBox are not direct platforms
 * where user need to enter secondary code on playstation or xbox site
 */
exports.isDirectPlatform = platform => {
    return !['psn', 'xbl'].includes(platform);
};
/**
 * PSN country code, eg. "us", "ca"
 */
exports.getPsnCountry = externalAuths => {
    let countryCode = null;
    for (const auth of externalAuths) {
        if (auth.type === 'psn') {
            const { regionInfo } = auth;
            if (regionInfo) {
                countryCode = regionInfo.toLowerCase();
            }
            break;
        }
    }
    return countryCode;
};
exports.getSuccessData = posaRedeemStore => {
    const { platform, page: { generalSuccess, psnSuccess, xblSuccess }, secondaryCode } = posaRedeemStore;
    if (!secondaryCode || !secondaryCode.code) {
        // secondaryCode not found, use general success data
        return generalSuccess;
    }
    switch (platform) {
        case 'mobile':
        case 'pc':
        case 'nitendo':
            return generalSuccess;
        case 'psn':
            return psnSuccess;
        case 'xbl':
            return xblSuccess;
        default:
            return generalSuccess;
    }
};
//# sourceMappingURL=index.js.map